import React from 'react'
import PropTypes from 'prop-types'
import {
  Icon,
  SocialX,
  SocialMetaFacebook,
  SocialLinkedIn,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const SOCIAL_CONFIG = {
  facebook: {
    icon: SocialMetaFacebook,
    defaultSize: { width: 22, height: 22 },
    defaultUrl: '//www.facebook.com/cgtrader/',
    ariaLabel: 'Facebook',
  },
  x: {
    icon: SocialX,
    defaultSize: { width: 20, height: 20 },
    defaultUrl: '//x.com/CG_Trader',
    ariaLabel: 'X (formerly Twitter)',
  },
  linkedin: {
    icon: SocialLinkedIn,
    defaultSize: { width: 28, height: 28 },
    defaultUrl: '//www.linkedin.com/company/cgtrader/',
    ariaLabel: 'LinkedIn',
  },
}

function SocialButton({
  type,
  url = '',
  className = '',
  iconClassName = '',
  size = null,
  iconColor = 'light',
}) {
  if (!SOCIAL_CONFIG[type]) {
    return null
  }

  const config = SOCIAL_CONFIG[type]
  const finalSize = size || config.defaultSize
  const finalUrl = url || config.defaultUrl

  return (
    <a
      className={`footer-social__link ${
        className || ''
      }`}
      href={finalUrl}
      target="_blank"
      aria-label={config.ariaLabel}
      rel="noreferrer"
    >
      <Icon
        svgComponent={config.icon}
        color={iconColor}
        className={iconClassName}
        size={finalSize}
      />
    </a>
  )
}

SocialButton.propTypes = {
  type: PropTypes.oneOf(['facebook', 'x', 'linkedin']).isRequired,
  url: PropTypes.string,
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  iconColor: PropTypes.string,
}

export default SocialButton
